import { ReorderButton } from "@/components/reorder";
import { useCustomerOrders } from "@/queries/orders";
import { RefreshCw } from "lucide-react";

/**
 * Header shortcut: reorder the salon's most recent order. It opens the same
 * review-before-confirm dialog as the Orders page, so nothing reaches the cart
 * unseen. Renders nothing until there is an order to repeat.
 */
export function QuickReorderButton() {
  const { data } = useCustomerOrders({ limit: 1 });
  const latest = data?.orders?.[0];

  if (!latest) {
    return null;
  }

  return (
    <ReorderButton
      orderId={latest.id}
      seller={latest.seller}
      currencyCode={latest.currency_code}
      source="header"
      variant="ghost"
      size="sm"
      label="Reorder last order"
      icon={RefreshCw}
      className="h-9 rounded-lg px-2 text-xs text-gray-700 hover:bg-gray-200/60"
    />
  );
}
